<template>
    <Modal v-slot="{ close }">
        <div class="modal-header">
            <h4 class="modal-header__title modal-header__title--centered">Заявка на цепь</h4>
        </div>
        <div class="modal__body">
            <div class="modal-alerts" >
                <transition name="slide-up">
                    <div class="alert" :class="{ 'alert--success': status.success, 'alert--error': status.error }" v-if="(status.error || status.success) && status.message.length > 0" v-html="status.message" @click="status.error = false"></div>
                </transition>
            </div>
            <div class="form-group form-group--label-column">
                <input type="text" class="form-group__input" id="modal-chain-count" v-model="form.count" autocomplete="off">
                <div class="form-group__label" :class="{'form-group__label--focus': form.count != ''}">Необходимое количество цепи в м.п.</div>
            </div>
            <div class="form-group form-group--label-column">
                <input type="text" class="form-group__input" id="modal-chain-elements" v-model="form.elements" autocomplete="off">
                <div class="form-group__label" :class="{'form-group__label--focus': form.elements != ''}">Кол-во соединительных звеньев шт.</div>
            </div>
            <div class="form-group">
                <textarea class="form-group__textarea" id="modal-chain-comment" v-model="form.comment"></textarea>
                <div class="form-group__label" :class="{'form-group__label--focus': form.comment != ''}">Поле для текста</div>
            </div>
            <div class="modal-buttons">
                <button type="button" class="btn modal-buttons__btn" v-html="status.sending ? 'Отправляем данные' : 'Отправить'" @click="sendForm"></button>
            </div>
        </div>
    </Modal>
</template>

<script>
export default {
    name: "modal-chain-conctructor",
};
</script>

<script setup>
import { ref, watch } from 'vue';
import axios from 'axios';
import Modal from '@js/components/ui/modals/modal';

const props = defineProps({
    steps: Array,
})
const emits = defineEmits(['close', 'success']);

const status = ref({
    message: '',
    error: null,
    success: null,
    sending: null,
    totalPercent: null,
})

const form = ref({
    count: '',
    elements: '',
    comment: '',
});

const sendForm = async () => {
    status.value.error = null;
    status.value.success = null;

    if (form.value.count == '') {
        status.value.error = true;
        status.value.message = 'Вы не указали необходимое количество цепи!';
        document.querySelector("#modal-chain-count").focus();
        return;
    }

    if (form.value.elements == '') {
        status.value.error = true;
        status.value.message = 'Вы не указали кол-во соединительных звеньев!';
        document.querySelector("#modal-chain-elements").focus();
        return;
    }

    if (!status.value.sending) {
        status.value.sending = true;

        let data = {
                form: {
                    steps: props.steps,
                    count: form.value.count,
                    elements: form.value.elements,
                    comment: form.value.comment,
                },
                _token: document.querySelector('meta[name="csrf"]')?.getAttribute('content')
            },
            headers = { "Content-Type": "application/json" }
        
        await axios
            .post("/cart/add/chain", data, { headers: headers })
            .then((response) => {
                emits('success', response.data);
            })
            .catch((error) => {
                status.value.success = null;
                status.value.totalPercent = null;
                if (error.response?.data.errors) {
                    for (let key in error.response.data.errors) {
                        document.querySelector("#modal-chain-" + key.replace('form.', '').replace('.', '_'))?.focus();
                        status.value.message = error.response.data.errors[key].join('<br>');
                        break;
                    }
                } else {
                    status.value.message = error.response?.data.message || error.message;
                    if (error.response?.data.focus) {
                        document.querySelector("#modal-chain-" + error.response.data.focus)?.focus();
                    }
                }
                status.value.sending = null;
                status.value.error = true;
            });
    }

}

const close = () => {
    emits('close');
}

</script>